(function () {
  angular.module("akitabox.ui.dialogs.message", [
    "akitabox.ui.dialogs.message.create",
    "akitabox.ui.dialogs.message.edit",
  ]);
})();
